module.exports = __webpack_public_path__ + "img/success.0665460e.svg";